/**
 * APP: Taako.
 *
 * Main Entry
 * Loads Intro animation, then toggles to App after intro complete
 *
 */

import React from 'react'
import ReactDOM from 'react-dom';
import './index.css';

import Intro from './Intro';
import App from './App';

import Modal from "./Modal";

import ResizeProvider from './Context/ResizeContext';
import WithResize from './Context/WithResize';
// import TweenMax from 'gsap/TweenMax'

const IntroWithResize = WithResize((v) => {
  return (
    <Intro {...v}/>
  )
})

const AppWithResize = WithResize((v) => {
  return (
    <App {...v}/>
  )
})

const ModalWithResize = WithResize((v) => {
  return (
    <Modal {...v}/>
  )
})



class Root extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showIntro: true,
      sidebarOpen: false,
      modalIsOpen: false,
      showModalType: 'info', // can be 'info' || 'transcript' || ''
      transcription: '',
      startApp: false
    }
  }

  componentDidMount() {
    this.setState({
      startApp: true
    })
  }

  introComplete = ( isComplete ) => {
    this.setState({
      showIntro: !isComplete
    })
  }

  toggleSidebar = ( open ) => {
    this.setState({
      sidebarOpen: open
    })
  }

  toggleModal = ( open ) => {
    this.setState({
      modalIsOpen: open
    })
  }

  setModalType = ( type ) => {
    this.setState({
      showModalType: type
    })
  }

  openInfoModal = () => {
    this.setModalType('info');
    this.toggleModal(true);
  }

  openTranscriptModal = () => {
    this.setModalType('transcript');
    this.toggleModal(true);
    if( this.state.showIntro ) {
      this.updateTranscriptModal('Click here to read the audio transcripts.');
    }
  }

  updateTranscriptModal = ( transcription ) => {
    if( this.state.showIntro ) {
      transcription = "<p>Click here to read audio transcripts when you are in the app.</p>";
    }
    this.setState({
      transcription: transcription
    })
  }

  attachApp = () => {
    return (
      <span>
        <ResizeProvider>

          <IntroWithResize observedBits={11}
                           introComplete={this.introComplete}
                           toggleSidebar={this.toggleSidebar}
                           toggleModal={this.toggleModal}
                           setModalType={this.setModalType}
                           updateTranscriptModal={this.updateTranscriptModal}/>

          <AppWithResize observedBits={11}
                         startApp={!this.state.showIntro}
                         toggleSidebar={this.toggleSidebar}
                         toggleModal={this.toggleModal}
                         setModalType={this.setModalType}
                         updateTranscriptModal={this.updateTranscriptModal} />

        </ResizeProvider>
        <ResizeProvider>
          {
            <ModalWithResize  isVisible={this.state.modalIsOpen}
                              type={this.state.showModalType}
                              payload={this.state.transcription}
                              toggleModal={this.toggleModal}/>
          }
        </ResizeProvider>
        <div id={"sub-navigation-container"} style={{display:'none'}}>
          <div id={"open-modal-container"} onClick={this.openInfoModal}>
            <img className={"open-modal-icon"} src={"https://www.taakoschool.com/qa/Assets/Image/button-info.png"} alt={""}/>
          </div>
          <div id={"open-modal-transcript-container"} onClick={this.openTranscriptModal}>
            <img className={"open-modal-icon"} src={"https://www.taakoschool.com/qa/Assets/Image/button-transcript.png"} alt={""}/>
          </div>
        </div>
      </span>
    )
  }

  attachBlankDiv = () => {
    return <div />
  }

  render() {
    return ( this.state.startApp ) ? this.attachApp() : this.attachBlankDiv()
  }

}

ReactDOM.render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js